import { gql } from '@apollo/client';

export const GET_SSI_NOTES = gql`
  query GetSsiNotes($studySiteInvestigatorId: UUID!) {
    ssiNotes(studySiteInvestigatorId: $studySiteInvestigatorId) {
      id
      studySiteInvestigatorId
      content
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
